/* globals _ */

import Itinerary from  './itinerary';

import { save as saveJson } from '../../service/json';
import { save as saveItinerary } from '../../service/itinerary';

const { values, pick, noop } = _;

export default Itinerary.extend( {
	key: 'session',

	initialize: function() {
		Itinerary.prototype.initialize.apply( this, arguments );

		this.on( 'change', () => {
			this.id = null;
		} );
	},

	bindReady: function() {
		return [
			'change',
			$elm => {
				var request = this.get( 'request' );

				var attrs = [];
				switch ( request ) {
					case 'ask':
						attrs = [ 'ask' ];
						break;

					case 'area':
						attrs = [ 'origin', 'date', 'mode', 'start', 'end' ];
						break;

					case 'road':
						attrs = [ 'origin', 'date', 'destination' ];
						break;
				}

				var ready = values( this.pick( attrs ) ).filter( v => v !== '' ).length == attrs.length;

				$elm.attr( 'disabled', ! ready );
			},
		];
	},

	save: function( callback ) {
		callback = callback || noop;

		if ( this.id ) {
			callback( this );
			return;
		}

		var uid = this.get( 'uid' );
		var data = pick( this.dump(), 'request', 'origin', 'origin_id', 'destination', 'destination_id', 'date', 'start', 'end', 'mode', 'title', 'distance', 'area', 'v' );

		data.stops = this.stops.map( stop => {
			return {
				id: stop.id,
				distance: stop.get( 'distance' ),
			};
		} );

		if ( uid ) {
			saveItinerary( {
				userId: uid,
				tripFrom: data.origin,
				tripTo: data.request === 'road' ? data.destination : null,
				tripName: data.title,
				tripDate: data.date,
				tripMode: data.mode,
				tripTime: data.start,
				tripStartTime: data.start,
				tripEndTime: data.end,
				tripType: data.request,
				tripStops: this.stops.pluck( 'id' ),
			}, resp => {
				flutterDebug( 'itinerary', resp );
			} );
		}

		saveJson( data, id => {
			this.id = id;
			callback( this );
		} );
	},
} );
